import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container flex _column" }
const _hoisted_2 = { class: "_flex" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 1,
  class: "blue_box folding_box not_fold"
}
const _hoisted_6 = { class: "box_tit _flex" }
const _hoisted_7 = { class: "_flex" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "_flex" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "fordable change_setting" }
const _hoisted_14 = {
  key: 0,
  class: "_flex"
}
const _hoisted_15 = { class: "select_date_wrap" }
const _hoisted_16 = { class: "select_date" }
const _hoisted_17 = { class: "con_con" }
const _hoisted_18 = { class: "con_con" }
const _hoisted_19 = { class: "con_con" }
const _hoisted_20 = { class: "_flex" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "_flex" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 5,
  class: "blue_box folding_box not_fold"
}
const _hoisted_27 = { class: "box_tit _flex" }
const _hoisted_28 = { class: "_flex" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "fordable footer_setting" }
const _hoisted_32 = { class: "agree_edit_wrap _flex" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  for: "add",
  class: "con_tit"
}
const _hoisted_35 = {
  for: "call",
  class: "con_tit"
}
const _hoisted_36 = {
  for: "fax",
  class: "con_tit"
}
const _hoisted_37 = {
  for: "email",
  class: "con_tit"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Left = _resolveComponent("Left")!
  const _component_BannerForMainpage = _resolveComponent("BannerForMainpage")!
  const _component_BoardEntireForMainpage = _resolveComponent("BoardEntireForMainpage")!
  const _component_BoardGamsiForMainpage = _resolveComponent("BoardGamsiForMainpage")!
  const _component_BannerPopupForMainpage = _resolveComponent("BannerPopupForMainpage")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!
  const _component_AgreeFormModal = _resolveComponent("AgreeFormModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createVNode(_component_Left),
    _createElementVNode("section", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.sectorList, (sector) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (sector.key === 'banner')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["blue_box folding_box", $setup.isShow.isShowBanner ? 'open' : ''])
              }, [
                _createElementVNode("div", {
                  class: "box_tit _flex",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.isShow.isShowBanner = !$setup.isShow.isShowBanner))
                }, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "move_up",
                      onClick: _withModifiers(($event: any) => ($setup.changeOrder(sector, 0)), ["stop"])
                    }, [...(_cache[23] || (_cache[23] = [
                      _createElementVNode("img", {
                        src: "img/up_icon.png",
                        alt: ""
                      }, null, -1)
                    ]))], 8, _hoisted_3),
                    _createElementVNode("button", {
                      type: "button",
                      class: "move_down",
                      onClick: _withModifiers(($event: any) => ($setup.changeOrder(sector, 1)), ["stop"])
                    }, [...(_cache[24] || (_cache[24] = [
                      _createElementVNode("img", {
                        src: "img/down_icon.png",
                        alt: ""
                      }, null, -1)
                    ]))], 8, _hoisted_4),
                    _cache[25] || (_cache[25] = _createElementVNode("h2", null, "배너", -1))
                  ]),
                  _cache[26] || (_cache[26] = _createElementVNode("button", {
                    type: "button",
                    class: "open_btn icon_wrap"
                  }, [
                    _createElementVNode("img", {
                      src: "img/more_icon.png",
                      alt: "더보기"
                    })
                  ], -1))
                ]),
                ($setup.isShow.isShowBanner)
                  ? (_openBlock(), _createBlock(_component_BannerForMainpage, { key: 0 }))
                  : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true),
          (sector.key === 'ad')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "move_up",
                      onClick: _withModifiers(($event: any) => ($setup.changeOrder(sector, 0)), ["stop"])
                    }, [...(_cache[27] || (_cache[27] = [
                      _createElementVNode("img", {
                        src: "img/up_icon.png",
                        alt: ""
                      }, null, -1)
                    ]))], 8, _hoisted_8),
                    _createElementVNode("button", {
                      type: "button",
                      class: "move_down",
                      onClick: _withModifiers(($event: any) => ($setup.changeOrder(sector, 1)), ["stop"])
                    }, [...(_cache[28] || (_cache[28] = [
                      _createElementVNode("img", {
                        src: "img/down_icon.png",
                        alt: ""
                      }, null, -1)
                    ]))], 8, _hoisted_9),
                    _cache[29] || (_cache[29] = _createElementVNode("h2", null, "성매매 업소, 알선광고 제보", -1))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (sector.key === 'statics')
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: _normalizeClass(["blue_box folding_box", $setup.isShow.isShowReport ? 'open' : ''])
              }, [
                _createElementVNode("div", {
                  class: "box_tit _flex",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.isShow.isShowReport = !$setup.isShow.isShowReport))
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "move_up",
                      onClick: _withModifiers(($event: any) => ($setup.changeOrder(sector, 0)), ["stop"])
                    }, [...(_cache[30] || (_cache[30] = [
                      _createElementVNode("img", {
                        src: "img/up_icon.png",
                        alt: ""
                      }, null, -1)
                    ]))], 8, _hoisted_11),
                    _createElementVNode("button", {
                      type: "button",
                      class: "move_down",
                      onClick: _withModifiers(($event: any) => ($setup.changeOrder(sector, 1)), ["stop"])
                    }, [...(_cache[31] || (_cache[31] = [
                      _createElementVNode("img", {
                        src: "img/down_icon.png",
                        alt: ""
                      }, null, -1)
                    ]))], 8, _hoisted_12),
                    _cache[32] || (_cache[32] = _createElementVNode("h2", null, "시민과 함께 만든 변화", -1))
                  ]),
                  _cache[33] || (_cache[33] = _createElementVNode("button", {
                    type: "button",
                    class: "open_btn icon_wrap"
                  }, [
                    _createElementVNode("img", {
                      src: "img/more_icon.png",
                      alt: "더보기"
                    })
                  ], -1))
                ]),
                _createElementVNode("div", _hoisted_13, [
                  ($setup.isShow.isShowReport)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", null, [
                          _cache[34] || (_cache[34] = _createElementVNode("span", { class: "con_tit" }, "기간설정", -1)),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _withDirectives(_createElementVNode("input", {
                                type: "date",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.mainViewInfo.date_main.value) = $event)),
                                onChange: _cache[3] || (_cache[3] = ($event: any) => ($setup.updateMainView($setup.mainViewInfo.date_main)))
                              }, null, 544), [
                                [_vModelText, $setup.mainViewInfo.date_main.value]
                              ])
                            ])
                          ]),
                          _cache[35] || (_cache[35] = _createTextVNode(" 까지 ", -1))
                        ]),
                        _createElementVNode("div", null, [
                          _cache[36] || (_cache[36] = _createElementVNode("span", { class: "con_tit" }, "전체 시민제보", -1)),
                          _createElementVNode("div", _hoisted_17, _toDisplayString($setup.mainViewInfo.cnt_report.value ? $setup.CommonUtils.numberFormat($setup.mainViewInfo.cnt_report.value) : "") + " 건 ", 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[38] || (_cache[38] = _createElementVNode("span", { class: "con_tit" }, "신고/ 고발", -1)),
                          _createElementVNode("div", _hoisted_18, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.mainViewInfo.cnt_citizen_report.value) = $event)),
                              onChange: _cache[5] || (_cache[5] = ($event: any) => ($setup.updateMainView($setup.mainViewInfo.cnt_citizen_report)))
                            }, null, 544), [
                              [_vModelText, $setup.mainViewInfo.cnt_citizen_report.value]
                            ]),
                            _cache[37] || (_cache[37] = _createTextVNode(" 건 ", -1))
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[39] || (_cache[39] = _createElementVNode("span", { class: "con_tit" }, "함께한 시민 수", -1)),
                          _createElementVNode("div", _hoisted_19, _toDisplayString($setup.mainViewInfo.cnt_citizen.value ? $setup.CommonUtils.numberFormat($setup.mainViewInfo.cnt_citizen.value) : "") + " 명 ", 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 2))
            : _createCommentVNode("", true),
          (sector.key === 'board_entire')
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: _normalizeClass(["blue_box folding_box", $setup.isShow.isShowActive ? 'open' : ''])
              }, [
                _createElementVNode("div", {
                  class: "box_tit _flex",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.isShow.isShowActive = !$setup.isShow.isShowActive))
                }, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "move_up",
                      onClick: _withModifiers(($event: any) => ($setup.changeOrder(sector, 0)), ["stop"])
                    }, [...(_cache[40] || (_cache[40] = [
                      _createElementVNode("img", {
                        src: "img/up_icon.png",
                        alt: ""
                      }, null, -1)
                    ]))], 8, _hoisted_21),
                    _createElementVNode("button", {
                      type: "button",
                      class: "move_down",
                      onClick: _withModifiers(($event: any) => ($setup.changeOrder(sector, 1)), ["stop"])
                    }, [...(_cache[41] || (_cache[41] = [
                      _createElementVNode("img", {
                        src: "img/down_icon.png",
                        alt: ""
                      }, null, -1)
                    ]))], 8, _hoisted_22),
                    _cache[42] || (_cache[42] = _createElementVNode("h2", null, "우리 함께 참여해요", -1))
                  ]),
                  _cache[43] || (_cache[43] = _createElementVNode("button", {
                    type: "button",
                    class: "open_btn icon_wrap"
                  }, [
                    _createElementVNode("img", {
                      src: "img/more_icon.png",
                      alt: "더보기"
                    })
                  ], -1))
                ]),
                ($setup.isShow.isShowActive)
                  ? (_openBlock(), _createBlock(_component_BoardEntireForMainpage, { key: 0 }))
                  : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true),
          (sector.key === 'board_news')
            ? (_openBlock(), _createElementBlock("div", {
                key: 4,
                class: _normalizeClass(["blue_box folding_box", $setup.isShow.isShowGamsi ? 'open' : ''])
              }, [
                _createElementVNode("div", {
                  class: "box_tit _flex",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.isShow.isShowGamsi = !$setup.isShow.isShowGamsi))
                }, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "move_up",
                      onClick: _withModifiers(($event: any) => ($setup.changeOrder(sector, 0)), ["stop"])
                    }, [...(_cache[44] || (_cache[44] = [
                      _createElementVNode("img", {
                        src: "img/up_icon.png",
                        alt: ""
                      }, null, -1)
                    ]))], 8, _hoisted_24),
                    _createElementVNode("button", {
                      type: "button",
                      class: "move_down",
                      onClick: _withModifiers(($event: any) => ($setup.changeOrder(sector, 1)), ["stop"])
                    }, [...(_cache[45] || (_cache[45] = [
                      _createElementVNode("img", {
                        src: "img/down_icon.png",
                        alt: ""
                      }, null, -1)
                    ]))], 8, _hoisted_25),
                    _cache[46] || (_cache[46] = _createElementVNode("h2", null, "감시소식", -1))
                  ]),
                  _cache[47] || (_cache[47] = _createElementVNode("button", {
                    type: "button",
                    class: "open_btn icon_wrap"
                  }, [
                    _createElementVNode("img", {
                      src: "img/more_icon.png",
                      alt: "더보기"
                    })
                  ], -1))
                ]),
                ($setup.isShow.isShowGamsi)
                  ? (_openBlock(), _createBlock(_component_BoardGamsiForMainpage, { key: 0 }))
                  : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true),
          (sector.key === 'subscribe')
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "move_up",
                      onClick: _withModifiers(($event: any) => ($setup.changeOrder(sector, 0)), ["stop"])
                    }, [...(_cache[48] || (_cache[48] = [
                      _createElementVNode("img", {
                        src: "img/up_icon.png",
                        alt: ""
                      }, null, -1)
                    ]))], 8, _hoisted_29),
                    _createElementVNode("button", {
                      type: "button",
                      class: "move_down",
                      onClick: _withModifiers(($event: any) => ($setup.changeOrder(sector, 1)), ["stop"])
                    }, [...(_cache[49] || (_cache[49] = [
                      _createElementVNode("img", {
                        src: "img/down_icon.png",
                        alt: ""
                      }, null, -1)
                    ]))], 8, _hoisted_30),
                    _cache[50] || (_cache[50] = _createElementVNode("h2", null, "뉴스레터 구독하기", -1))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      }), 256)),
      _cache[55] || (_cache[55] = _createElementVNode("div", { class: "line" }, null, -1)),
      _createElementVNode("div", {
        class: _normalizeClass(["blue_box folding_box", $setup.isShow.isShowBannerPopup ? 'open' : ''])
      }, [
        _createElementVNode("div", {
          class: "box_tit _flex",
          onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.isShow.isShowBannerPopup = !$setup.isShow.isShowBannerPopup))
        }, [...(_cache[51] || (_cache[51] = [
          _createElementVNode("div", { class: "_flex" }, [
            _createElementVNode("h2", null, "팝업 배너")
          ], -1),
          _createElementVNode("button", {
            type: "button",
            class: "open_btn icon_wrap"
          }, [
            _createElementVNode("img", {
              src: "img/more_icon.png",
              alt: "더보기"
            })
          ], -1)
        ]))]),
        ($setup.isShow.isShowBannerPopup)
          ? (_openBlock(), _createBlock(_component_BannerPopupForMainpage, { key: 0 }))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["blue_box folding_box", $setup.isShow.isShowFooter ? 'open' : ''])
      }, [
        _createElementVNode("div", {
          class: "box_tit _flex",
          onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.isShow.isShowFooter = !$setup.isShow.isShowFooter))
        }, [...(_cache[52] || (_cache[52] = [
          _createElementVNode("div", { class: "_flex" }, [
            _createElementVNode("h2", null, "푸터")
          ], -1),
          _createElementVNode("button", {
            type: "button",
            class: "open_btn icon_wrap"
          }, [
            _createElementVNode("img", {
              src: "img/more_icon.png",
              alt: "더보기"
            })
          ], -1)
        ]))]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", null, [
              _cache[53] || (_cache[53] = _createTextVNode(" 서비스 이용약관 ", -1)),
              _createElementVNode("button", {
                type: "button",
                class: "table_btn _blue",
                onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.agreeFormModal(2)))
              }, "수정")
            ]),
            _createElementVNode("div", null, [
              _cache[54] || (_cache[54] = _createTextVNode(" 개인정보 처리 방침 ", -1)),
              _createElementVNode("button", {
                type: "button",
                class: "table_btn _blue",
                onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.agreeFormModal(1)))
              }, "수정")
            ])
          ]),
          ($setup.isShow.isShowFooter)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_33, [
                _createElementVNode("li", null, [
                  _createElementVNode("label", _hoisted_34, _toDisplayString($setup.mainViewInfo.address.name), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "add",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.mainViewInfo.address.value) = $event)),
                    onChange: _cache[13] || (_cache[13] = ($event: any) => ($setup.updateMainView($setup.mainViewInfo.address)))
                  }, null, 544), [
                    [_vModelText, $setup.mainViewInfo.address.value]
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("label", _hoisted_35, _toDisplayString($setup.mainViewInfo.phone.name), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "call",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.mainViewInfo.phone.value) = $event)),
                    onChange: _cache[15] || (_cache[15] = ($event: any) => ($setup.updateMainView($setup.mainViewInfo.phone)))
                  }, null, 544), [
                    [_vModelText, $setup.mainViewInfo.phone.value]
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("label", _hoisted_36, _toDisplayString($setup.mainViewInfo.fax.name), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "fax",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.mainViewInfo.fax.value) = $event)),
                    onChange: _cache[17] || (_cache[17] = ($event: any) => ($setup.updateMainView($setup.mainViewInfo.fax)))
                  }, null, 544), [
                    [_vModelText, $setup.mainViewInfo.fax.value]
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("label", _hoisted_37, _toDisplayString($setup.mainViewInfo.email.name), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "email",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.mainViewInfo.email.value) = $event)),
                    onChange: _cache[19] || (_cache[19] = ($event: any) => ($setup.updateMainView($setup.mainViewInfo.email)))
                  }, null, 544), [
                    [_vModelText, $setup.mainViewInfo.email.value]
                  ])
                ]),
                _createElementVNode("li", null, [
                  _withDirectives(_createElementVNode("textarea", {
                    name: "",
                    id: "",
                    placeholder: "추가하고 싶은 내용을 입력하세요.",
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.mainViewInfo.footer.value) = $event)),
                    onChange: _cache[21] || (_cache[21] = ($event: any) => ($setup.updateMainView($setup.mainViewInfo.footer)))
                  }, null, 544), [
                    [_vModelText, $setup.mainViewInfo.footer.value]
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true),
    ($setup.state.isShowAgreeFormModal)
      ? (_openBlock(), _createBlock(_component_AgreeFormModal, {
          key: 1,
          gubun: $setup.mainViewInfo.gubun,
          data: $setup.mainViewInfo.data,
          onClose: _cache[22] || (_cache[22] = ($event: any) => ($setup.state.isShowAgreeFormModal = false)),
          onCallback: $setup.updateMainView
        }, null, 8, ["gubun", "data", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}